import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { InitApolloOptions } from "@paperlesspost/next-with-apollo";

import isServer from "../utils/isServer";

function getGraphQLUrl() {
  // convinience for local development
  if (process.env.NEXT_PUBLIC_GRAPHQL_API_URL_FOR_LOCAL_DEV) {
    return `${process.env.NEXT_PUBLIC_GRAPHQL_API_URL_FOR_LOCAL_DEV}/graphql`;
  }

  if (isServer()) {
    return `${process.env.GRAPHQL_API_URL}/graphql`;
  }

  return `${window.location.origin}/flyer/api/graphql`;
}

const getApolloClient = ({ initialState }: InitApolloOptions<any>) => {
  return new ApolloClient({
    link: new HttpLink({
      uri: getGraphQLUrl(),
      credentials: 'include'
    }),
    cache: new InMemoryCache().restore(initialState || {}),
  });
};

export default getApolloClient;
